var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalDocumentCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.1 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.6 19.3H28M19.3 12.5H28"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.6,
    cy: 12.5,
    r: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.6 24.5h5M23 24.5h5M13.6 29.7h5M23 29.7h5M27.6 4.8H13.4c-3.1 0-5.7 2.5-5.7 5.7v18.9M14.3 37.3h14.4c3.1 0 5.7-2.5 5.7-5.7V12.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.4 4.8L8.3 37.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalDocumentCancel);
export default __webpack_public_path__ + "static/media/internalDocumentCancel.a8ee5e53df05015eb0b32a3b41f9d926.svg";
export { ForwardRef as ReactComponent };